/**
 * @file utils/path/library.js
 * @copyright 2016 CBC/Radio-Canada. All rights reserved.
 * This file contains methods that are run as react-router's onEnter callbacks
 * More info here: https://github.com/reactjs/react-router/blob/master/docs/API.md#onenternextstate-replace-callback
 */

import * as CONSTANTS from "./constants";
import { getFeedCookie, createFeedCookie } from "../cookies/library";
import { request } from "../promises/library";
import log from "../logger/library";
import { isServer } from "../environmentDetection/library";

/**
 * Checks to see if server version of the app is the same as the one loaded in the browser.
 * If the versions match, it sets a cookie to short circuit this method the next time it is executed.
 * If the versions don't match, it will force a window reload.
 * This method should only run in the browser and when the cbc_app_version cookie is present.
 */
export const checkAppVersion = () => {
    if (
        isServer() ||
        window.__APP_VERSION__ === "" ||
        getFeedCookie("cbc_app_version") !== null
    ) {
        return;
    }
    return request(
        `${window.location.protocol}//${window.location.hostname}${
            window.location.port === "" ? "" : ":" + window.location.port
        }${CONSTANTS.APP_VERSION_PATH}`
    )
        .then((res) => res.json())
        .then((json) => {
            createFeedCookie(
                "cbc_app_version",
                json.version,
                CONSTANTS.TWO_MINUTES_AS_1000_DAYS
            );
            if (json.version !== window.__APP_VERSION__) {
                window.location.reload(true);
            }
        })
        .catch((error) => {
            log.error("(checkAppVersion)", error);
        });
};
